import { Row, RenderConfig, TextInput, Column, EMPTY_ARRAY, SelectInput, TextAreaInput } from 'commons-ui';
import { GAME_OPTIONS } from 'pages/dashboard/athenaDashboard/listAthenaRequest/constants';

export const FORM_FIELD_KEYS = {
	GAME_NAME: 'gameName',
	QUERY_TEXT: 'queryText',
	DEFAULT_QUERY_PARAMS: 'defaultQueryParams',
	LABEL: 'label'
};
export const FORM_FIELD_LABELS: {
	[key: string]: string;
} = {
	[FORM_FIELD_KEYS.GAME_NAME]: 'Game Name',
	[FORM_FIELD_KEYS.QUERY_TEXT]: 'Query Text',
	[FORM_FIELD_KEYS.DEFAULT_QUERY_PARAMS]: 'Default Query Params',
	[FORM_FIELD_KEYS.LABEL]: 'Label'
};

export const FORM_FIELD_CONFIG: {
	[key: string]: RenderConfig;
} = {
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.GAME_NAME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.GAME_NAME])
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: GAME_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.QUERY_TEXT]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.QUERY_TEXT)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.QUERY_TEXT])
		.setRenderer(TextAreaInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.DEFAULT_QUERY_PARAMS]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.DEFAULT_QUERY_PARAMS)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.DEFAULT_QUERY_PARAMS])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.LABEL]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.LABEL)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.LABEL])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		})
};

export const FORM_LAYOUT_CONFIG: Row[] = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.GAME_NAME)]), new Column([new Row(FORM_FIELD_KEYS.LABEL)])]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.DEFAULT_QUERY_PARAMS)]),
		new Column([new Row(FORM_FIELD_KEYS.QUERY_TEXT)])
	])
];
